"use client";

import { c as _c } from "react/compiler-runtime";
import ReviewAnalysis from "../ReviewAnalysis";
import { Typography } from "@/shared/ui/atoms";
import { useInfiniteQueryHospitalReview, useCheckHospitalCollection } from "@/entities/hospital/hooks/queries";
import { ReviewList } from "@/features/hospital/ui/templates";
import { useGetLocale } from "@/shared/hooks/useGetLocale";
import { useFeaturesHospitalStore } from "@/features/hospital/model/store";
import { Review } from "@/shared/ui/molecules";
import { useTranslations } from "next-intl";
import { useHospitalOriginId } from "@/entities/hospital/model/hospital-origin-id";
interface HospitalReviewProps {
  /**
   * 새 상세 페이지의 섹션 셸 안에 들어갈 때. 제목과 바깥 여백은 섹션이 갖고 있으므로
   * 여기서는 내용만 그린다. 기본값(false)은 기존 상세 페이지의 모습 그대로다.
   */
  embedded?: boolean;
}
const HospitalReview = t0 => {
  const $ = _c(33);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    embedded: t2
  } = t1;
  const embedded = t2 === undefined ? false : t2;
  const t = useTranslations();
  const locale = useGetLocale();
  const hospitalId = useHospitalOriginId();
  const {
    selectedReviewSort
  } = useFeaturesHospitalStore();
  const {
    data,
    fetchNextPage,
    hasNextPage
  } = useInfiniteQueryHospitalReview(hospitalId, selectedReviewSort, locale);
  const {
    data: isCollection
  } = useCheckHospitalCollection(hospitalId, locale);
  const isCollectionResult = isCollection?.result ?? false;
  const totalReviewCount = data?.pages?.[0]?.result?.reviewList?.totalElements ?? 0;
  let T0;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[2] !== data?.pages || $[3] !== embedded || $[4] !== fetchNextPage || $[5] !== hasNextPage || $[6] !== isCollectionResult || $[7] !== t || $[8] !== totalReviewCount) {
    const reviewList = data?.pages.flatMap(_temp) ?? [];
    const isEmpty = reviewList.length === 0;
    if ($[17] !== embedded || $[18] !== t || $[19] !== totalReviewCount) {
      t8 = embedded ? null : <Typography size={18} className="px-4 pt-6 pb-3 text-gray-900 font-bold">{t("info.review")} {totalReviewCount.toLocaleString("ko-KR")}</Typography>;
      $[17] = embedded;
      $[18] = t;
      $[19] = totalReviewCount;
      $[20] = t8;
    } else {
      t8 = $[20];
    }
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = <ReviewAnalysis />;
      $[21] = t9;
    } else {
      t9 = $[21];
    }
    T0 = ReviewList;
    t3 = isEmpty;
    t4 = fetchNextPage;
    t5 = hasNextPage ?? false;
    t6 = isCollectionResult;
    t7 = reviewList.map(_temp2);
    $[2] = data?.pages;
    $[3] = embedded;
    $[4] = fetchNextPage;
    $[5] = hasNextPage;
    $[6] = isCollectionResult;
    $[7] = t;
    $[8] = totalReviewCount;
    $[9] = T0;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    T0 = $[9];
    t3 = $[10];
    t4 = $[11];
    t5 = $[12];
    t6 = $[13];
    t7 = $[14];
    t8 = $[15];
    t9 = $[16];
  }
  let t10;
  if ($[22] !== T0 || $[23] !== t3 || $[24] !== t4 || $[25] !== t5 || $[26] !== t6 || $[27] !== t7) {
    t10 = <T0 isEmpty={t3} fetchNextPage={t4} hasNextPage={t5} isCollection={t6}>{t7}</T0>;
    $[22] = T0;
    $[23] = t3;
    $[24] = t4;
    $[25] = t5;
    $[26] = t6;
    $[27] = t7;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  let t11;
  if ($[29] !== t10 || $[30] !== t8 || $[31] !== t9) {
    t11 = <div>{t8}{t9}{t10}</div>;
    $[29] = t10;
    $[30] = t8;
    $[31] = t9;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  return t11;
};
export default HospitalReview;
function _temp(page) {
  return page.result?.reviewList?.contents || [];
}
function _temp2(review, index) {
  return <Review key={`review-${index}`} review={review} />;
}